<template>
    <div>
        <div class="simple-form flex col-3">
            <div class="form-group center">
                <div class="form-label">
                    <label>供方名称</label>
                </div>
                <div class="form-value" :title="voucher.sellerName">{{voucher.sellerName}}</div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>交易单号</label>
                </div>
                <div class="form-value" :title="voucher.no">{{voucher.no}}</div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>自用合同编号</label>
                </div>
                <div class="form-value" :title="voucher.fstPartyHtBh">{{voucher.fstPartyHtBh}}</div>
            </div>
        </div>
        <div class="simple-form flex col-3" v-if="tradeFlag == 'goods'">
            <div class="form-group center">
                <div class="form-label">
                    <label>合同商品总数量</label>
                </div>
                <div class="form-value" :title="voucher.contractGoodsCount">{{voucher.contractGoodsCount || 0}}</div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>已收货数量</label>
                </div>
                <div class="form-value" :title="voucher.recvGoodsCount">{{voucher.recvGoodsCount || 0}}</div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>已退货数量</label>
                </div>
                <div class="form-value" :title="voucher.returnGoodsCount">{{voucher.returnGoodsCount || 0}}</div>
            </div>
        </div>
        <div class="simple-form flex col-3" v-if="tradeFlag == 'integ' || tradeFlag == 'servc'">
            <div class="form-group center">
                <div class="form-label">
                    <label>合同服务总次数</label>
                </div>
                <div class="form-value" :title="voucher.contractServcCount">{{voucher.contractServcCount || 0}}</div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>已完成次数</label>
                </div>
                <div class="form-value" :title="voucher.servcFinishedCount">{{voucher.servcFinishedCount || 0}}</div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>响应平均时长(分钟)</label>
                </div>
                <div class="form-value" :title="voucher.rspTimeMiAvg">{{voucher.rspTimeMiAvg || 0}}</div>
            </div>
        </div>
        <div class="simple-form flex col-3">
            <div class="form-group center">
                <div class="form-label">
                    <label>预计交易总金额(元)</label>
                </div>
                <div class="form-value" :title="voucher.estmtAmount">{{(voucher.estmtAmount || 0).toFixed(2)}}</div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>累计订单金额(元)</label>
                </div>
                <div class="form-value" :title="voucher.totalZxAmount">{{(voucher.totalZxAmount || 0).toFixed(2)}}</div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>实际付款金额(元)</label>
                </div>
                <div class="form-value" :title="voucher.paidAmount">{{(voucher.paidAmount || 0).toFixed(2)}}</div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>申请中金额(元)</label>
                </div>
                <div class="form-value" :title="voucher.applingPayAmount">{{(voucher.applingPayAmount || 0).toFixed(2)}}</div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>已退款金额(元)</label>
                </div>
                <div class="form-value" :title="voucher.refundedAmount">{{(voucher.refundedAmount || 0).toFixed(2)}}</div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>所处合同阶段</label>
                </div>
                <div class="form-value" :title="voucher.trackPhaseName">{{voucher.trackPhaseName}}</div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>合同是否交付完成</label>
                </div>
                <div class="form-value">
                    <span v-if="voucher.deliverFinished">是</span>
                    <span v-else>否</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>合同是否支付完成</label>
                </div>
                <div class="form-value">
                    <span v-if="voucher.payFinished">是</span>
                    <span v-else>否</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>交易创建时间</label>
                </div>
                <div class="form-value" :title="voucher.createTime">{{voucher.createTime}}</div>
            </div>
        </div>
        <div v-for="trackPhase in voucher.trackPhaseList">
            <div class="content-caption dashed">
                <span>{{trackPhase.name}}</span>
            </div>
            <div class="simple-form flex col-3">
                <template v-if="tradeFlag == 'goods' || tradeFlag == 'integ'">
                    <div class="form-group center">
                        <div class="form-label">
                            <label>预计阶段商品总数量</label>
                        </div>
                        <div class="form-value" :title="trackPhase.goodsDeliverCount">{{trackPhase.goodsDeliverCount || 0}}</div>
                    </div>
                    <div class="form-group center">
                        <div class="form-label">
                            <label>阶段商品总数量</label>
                        </div>
                        <div class="form-value" :title="trackPhase.estmtGoodsCount">{{trackPhase.estmtGoodsCount || 0}}</div>
                    </div>
                    <div class="form-group center">
                        <div class="form-label">
                            <label>阶段已收货数量</label>
                        </div>
                        <div class="form-value" :title="trackPhase.recvGoodsCount">{{trackPhase.recvGoodsCount || 0}}</div>
                    </div>
                </template>
                <template v-if="tradeFlag == 'integ' || tradeFlag == 'servc'">
                    <template v-if="tradeFlag == 'servc'">
                        <div class="form-group center">
                            <div class="form-label">
                                <label>预计阶段服务总次数</label>
                            </div>
                            <div class="form-value" :title="trackPhase.goodsDeliverCount">{{trackPhase.goodsDeliverCount || 0}}</div>
                        </div>
                    </template>
                    <div class="form-group center">
                        <div class="form-label">
                            <label>阶段服务总次数</label>
                        </div>
                        <div class="form-value" :title="trackPhase.servcCount">{{trackPhase.servcCount || 0}}</div>
                    </div>
                    <div class="form-group center">
                        <div class="form-label">
                            <label>阶段已完成次数</label>
                        </div>
                        <div class="form-value" :title="trackPhase.servcFinishedCount">{{trackPhase.servcFinishedCount || 0}}</div>
                    </div>
                </template>
            </div>
            <div class="simple-form flex col-3">
                <div class="form-group center">
                    <div class="form-label">
                        <label>阶段应付金额(元)</label>
                    </div>
                    <div class="form-value" :title="trackPhase.amountPay">{{(trackPhase.amountPay || 0).toFixed(2)}}</div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>阶段已付金额(元)</label>
                    </div>
                    <div class="form-value" :title="trackPhase.paidAmount">{{(trackPhase.paidAmount || 0).toFixed(2)}}</div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>阶段已退金额(元)</label>
                    </div>
                    <div class="form-value" :title="trackPhase.refundedAmount">{{(trackPhase.refundedAmount || 0).toFixed(2)}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import tradeApi from '../../api/trade'
    export default{
        name: 'swb-trade-voucher-dto-detail',
        desc: '交易数据详情',
        props: ["tradeId", 'tradeFlag', 'trackPhaseId'],
        data: function () {
            return {
                voucher: {}
            }
        },
        created: function () {
            //
            this.getTradeVoucherDtoDetail(this.tradeId, this.trackPhaseId);
        },
        methods: {
            getTradeVoucherDtoDetail: function (id, trackPhaseId) {
                let self = this;
                let postData = {};
                postData.id = id;
//                postData.trackPhaseId = trackPhaseId;
                //
                let msgBoxDlg = MsgBox.loading();
                tradeApi.getTradeVoucherDtoPhaseInfo(postData, function (result) {
                    msgBoxDlg.close();
                    if(result.type == 'info') {
                        self.voucher = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            }
        }
    }
</script>
<style>
    .form-info .form-row.col .form-label {
        width: 130px;
    }

    .form-info .form-row.col .form-value {
        width: calc(100% - 130px - 20px);
        width: -webkit-calc(100% - 130px - 20px);
        width: -moz-calc(100% - 130px - 20px);
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;

    }
</style>



// WEBPACK FOOTER //
// src/compo/tradeVoucher/TradeDetail.vue